/**
 * Progress bar component.
 *
 * The bar only fills once the run has told us how many nodes it will execute
 * (`total_nodes` on the first `node_start`). Until then it shows the step name
 * alone — an invented percentage is worse than none, because the user reads it
 * as a real estimate of how long they have to wait.
 */

import type { FunctionComponent } from 'preact'

interface ProgressBarProps {
  percentage: number | null
  currentNode?: string
}

export const ProgressBar: FunctionComponent<ProgressBarProps> = ({
  percentage,
  currentNode,
}) => {
  return (
    <>
      <div class="syv-progress-text">
        {currentNode ? `Kører: ${currentNode}` : 'Kører…'}
      </div>
      {percentage === null ? (
        <div class="syv-progress syv-progress-indeterminate" />
      ) : (
        <div class="syv-progress">
          <div
            class="syv-progress-bar"
            style={{ width: `${Math.min(100, Math.max(0, percentage))}%` }}
          />
        </div>
      )}
    </>
  )
}
